<div class="navbar-wrapper">
    <div class="navbar-header">
        <ul class="nav navbar-nav flex-row">
            <li class="nav-item mobile-menu d-md-none mr-auto">
                <a class="nav-link nav-menu-main menu-toggle hidden-xs">
                    <i class="ft-menu font-large-1"></i>
                </a>
            </li>
            <!-- Logo admin -->
            <li class="nav-item">
                <a class="navbar-brand" routerLink="/dashboard">
                    <img class="brand-logo" alt="robust admin logo" src="./../../../assets/images/kuppel-04.png">
                    <h3 class="brand-text">Kuppel Admin</h3>
                </a>
            </li>
            <li class="nav-item d-md-none">
                <a class="nav-link open-navbar-container" data-toggle="collapse" data-target="#navbar-mobile"><i class="fa fa-ellipsis-v"></i></a>
            </li>
        </ul>
    </div>
    <div class="navbar-container content">
        <div class="collapse navbar-collapse" id="navbar-mobile">
            <ul class="nav navbar-nav mr-auto float-left">
                <li class="nav-item d-none d-md-block">
                    <a class="nav-link nav-menu-main menu-toggle hidden-xs" href="#">
                        <i class="ft-menu"></i>
                    </a>
                </li>
            </ul>
            <ul class="nav navbar-nav float-right">
                <li class="dropdown dropdown-user nav-item">
                    <a class="dropdown-toggle nav-link dropdown-user-link" href="#" data-toggle="dropdown">
                        <span class="avatar avatar-online">
                            <img src="https://cdn.kuppel.co/robust/images/portrait/small/avatar-s-1.png" alt="avatar"><i></i></span>
                        <span class="user-name">{{getName()}}</span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="#">
                            <i class="ft-user"></i>
                            Edit Profile
                        </a>
                        <a class="dropdown-item" href="#">
                            <i class="ft-mail"></i>
                            My Inbox
                        </a>
                        <a class="dropdown-item" href="#">
                            <i class="ft-check-square"></i> 
                            Task
                        </a>
                        <a class="dropdown-item" href="#">
                            <i class="ft-message-square"></i>
                            Chats
                        </a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" (click)="logout()">
                            <i class="ft-power"></i>
                            Logout
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>